import { Clock } from "lucide-react";

const formatDuration = (mins) => {
  if (mins >= 1440) {
    const d = Math.round(mins / 1440);
    return `${d} day${d > 1 ? "s" : ""}`;
  }
  if (mins >= 60) {
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return m ? `${h}h ${m}m` : `${h} hour${h > 1 ? "s" : ""}`;
  }
  return `${mins} min`;
};

export default function Step1Services({ services, selected, onChange }) {
  const toggle = (id) => {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    onChange(Array.from(next));
  };

  const totalDuration = services
    .filter((s) => selected.includes(s.service_id))
    .reduce((acc, s) => acc + s.duration, 0);

  return (
    <div className="pp-step-fade" data-testid="step-1-services">
      <h2 className="text-xl md:text-2xl font-medium mb-1">Choose your services</h2>
      <p className="text-xs sm:text-sm mb-3" style={{ color: "var(--pp-muted)" }}>
        Select one or more — durations will be combined.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5" role="group" aria-label="Services">
        {services.map((s) => {
          const checked = selected.includes(s.service_id);
          return (
            <label
              key={s.service_id}
              className="flex items-center justify-between gap-2 px-3 py-2.5 cursor-pointer transition-all"
              style={{
                border: `1px solid ${checked ? "var(--pp-indigo)" : "var(--pp-border)"}`,
                background: checked ? "var(--pp-indigo-soft)" : "#fff",
                borderRadius: "var(--pp-radius)",
                minHeight: 56,
              }}
              data-testid={`service-card-${s.service_id}`}
            >
              <div className="flex items-center gap-2.5 min-w-0">
                <input
                  type="checkbox"
                  className="w-5 h-5 cursor-pointer accent-[#4D54AB] flex-shrink-0"
                  checked={checked}
                  onChange={() => toggle(s.service_id)}
                  data-testid={`service-checkbox-${s.service_id}`}
                />
                <div className="min-w-0">
                  <div className="font-medium text-sm truncate" style={{ color: "var(--pp-ink)" }}>
                    {s.name}
                  </div>
                  <div className="text-xs flex items-center gap-1" style={{ color: "var(--pp-muted)" }}>
                    <Clock className="w-3 h-3 flex-shrink-0" />
                    {formatDuration(s.duration)}
                  </div>
                </div>
              </div>
              {checked ? (
                <span
                  className="text-[10px] font-semibold uppercase tracking-wider flex-shrink-0"
                  style={{ color: "var(--pp-indigo)" }}
                >
                  ✓
                </span>
              ) : null}
            </label>
          );
        })}
      </div>
      <div
        className="mt-3 px-3 py-2 flex items-center justify-between"
        style={{ background: "var(--pp-cream-soft)", borderRadius: "var(--pp-radius)" }}
        data-testid="services-total"
      >
        <span className="text-xs sm:text-sm" style={{ color: "var(--pp-muted)" }}>
          Total duration
        </span>
        <span className="font-semibold text-sm" style={{ color: "var(--pp-ink)" }} data-testid="services-total-value">
          {selected.length === 0 ? "—" : formatDuration(totalDuration)}
        </span>
      </div>
    </div>
  );
}
